export interface NotificationMessage {
  submitSplitSuccess: (mandateId: string, splitCount: number, splitType: string) => string;
  submitSuccess: string;
  saveSuccess: string;
  approveSuccess: string;
  saveFail: string;
  submissionFailed: string;
  somethingWentWrong: string;
  mdeAssign: string;
  medicalAccomodationCertify:string;
  medicalAccomodationApprovalStatus:string;
  notAssignedProvider: string;
  selectedSlotUnavailable: string;
  selectedSlotUnavailableWithReason: (reason: string) => string;
}

export const NOTIFICATION_MESSAGES: NotificationMessage = {
  submitSplitSuccess: (
    mandateId: string,
    splitCount: number,
    splitType: string
  ) =>
    `${mandateId}: successfully split into ${splitCount} assignment rows. (Split Type: ${splitType})`,
  submitSuccess: 'Submitted Successfully',
  saveSuccess: 'Saved Successfully',
  approveSuccess: 'Approved Successfully',
  saveFail: 'Save Failed',
  submissionFailed: 'Submission Failed',
  somethingWentWrong: 'Something went wrong..',
  mdeAssign: 'This will add the student in the selected agency’s waitlist. The agency will contact the parent or the parent can contact them to get an appointment scheduled.',
  medicalAccomodationCertify: 'The approval status provided by the physician must be certified in order for this document to be finalized.',
  medicalAccomodationApprovalStatus:'Approval status must be completed for every transportation accommodation before finalizing this document.',
  notAssignedProvider: 'The selected item(s) are not assigned to a provider. This action cannot be performed.',
  selectedSlotUnavailable: 'Selected slots are not available. Please choose different slots.',
  selectedSlotUnavailableWithReason: (reason: string) =>
    `Selected slot not available - ${reason}`,
};

export interface DialogMessages {
  confirmTitle: string;
  areYouSureMessage: string;
  deleteDocumentMessage: string;
  cancelDocumentMessage: string;
  withdrawlContent: string;
  submitConsentContent: string;
  confirmYes: string;
  confirmNo: string;
  confirm: string;
  confirmAndContinue: string;
  pleaseConfirmActionCannotBeUndone: string;
  actionWillCancelReferralPleaseConfirm: string;
  save: string;
  doYouWishToSubmit: string;
  nursingLeaveIEP: string;
}

export const DIALOG_MESSAGES: DialogMessages = {
  confirmTitle: 'Please confirm',
  areYouSureMessage: 'Are you sure?',
  deleteDocumentMessage: 'Are you sure you want to delete the document?',
  cancelDocumentMessage: 'Are you sure you want to cancel?',
  withdrawlContent:
    'I am in agreement with the recommendations made at this meeting for alternatives to special education.  I understand that the initial referral will be withdrawn.',
  submitConsentContent:
    'Parent/Principal Written Agreement to Withdraw an Initial Referral Successful.',
  confirmYes: 'Yes',
  confirmNo: 'No',
  confirm: 'Confirm',
  confirmAndContinue: 'Confirm and Continue',
  pleaseConfirmActionCannotBeUndone:
    'Please confirm you\'re ready to submit this form. This action cannot be undone.',
  actionWillCancelReferralPleaseConfirm:
    'This action will cancel the referral - all data will be lost. Are you sure you want to continue?',
  save: 'Save',
  doYouWishToSubmit: 'Do you wish to submit?',
  nursingLeaveIEP:'Leave the IEP?'
};

export const OUTSTANDING_ASSESSMENTS_TEXT: string =
  'You have outstanding assessments. Please either get them finalized and reconvene the IEP meeting or remove them if they are no longer necessary and proceed to create a ';

export const MANDATED_THREE_YEAR_REEVALUATION_TEXT: string =
  ' Mandated Three-Year reevaluation';

export const NEW_ADDITIONAL_REEVALUATION_TEXT: string =
  ' new additioal reevaluation';

export const NEW_REEVALUATION: string = ' new reevaluation';

export const DATE_OF_BIRTH_MISSING: string =
  'Date of Birth missing on Student record';

export enum IhmsNotificationMessageKeys {
  AssignSuccess = 'assignSuccess',
  ReassignSuccess = 'reassignSuccess',
  SentBackSuccess = 'sentBackSuccess',
  CompletedSuccess = 'completedSuccess',
}

interface NotificationMessageFunctions {
  [IhmsNotificationMessageKeys.AssignSuccess]: (
    actionItem: string,
    person: string
  ) => string;
  [IhmsNotificationMessageKeys.ReassignSuccess]: (
    actionItem: string,
    person: string
  ) => string;
  [IhmsNotificationMessageKeys.SentBackSuccess]: (actionItem: string) => string;
  [IhmsNotificationMessageKeys.CompletedSuccess]: (
    actionItem: string
  ) => string;
}

// 2. Function or object to generate messages with dynamic parts
export const IhmsNotificationMessages: NotificationMessageFunctions = {
  assignSuccess: (actionItem: string, person: string) =>
    `The action item ‘${actionItem}’ has been successfully assigned to ${person}.`,
  reassignSuccess: (actionItem: string, person: string) =>
    `The action item ‘${actionItem}’ has been successfully reassigned to ${person}.`,
  sentBackSuccess: (actionItem: string) =>
    `The action item ‘${actionItem}’ has been successfully sent back to IHMS.`,
  completedSuccess: (actionItem: string) =>
    `The action item ‘${actionItem}’ has been successfully completed.`,
};
